import { Card, useTranslation } from '@components';
import NotificationsCenter from '@containers/notifications/NotificationsCenterContainer';
import type { IWork } from '@models';
import * as React from 'react';

import './SelectWork.scss';

export interface IProps {
    works: IWork[];
    selectWork: Function;
}

const WorkCard = ({ work, selectWork }: {
    work: IWork,
    selectWork: Function,
}) => {
    // return <div style={{width:'30%'}} onClick={_ => selectWork(work.id)}>
    //         <div className='work-card'>
    //             <img src={work.settingsObj?.clientImage ?? '/img/works/soltec.png'} alt='gstore'/>
    //         </div>
    //     </div>;

    const [clientImage, setClientImage] = React.useState<string>('/img/screen/soltec.png');

    const { t } = useTranslation();

    React.useEffect(() => {
        if (work.settingsObj?.clientImage) {
            setClientImage(work.settingsObj?.clientImage);
        }
    }
    , [work.settingsObj?.clientImage]);

    var workClass = `card-select-work pointer work-22 work-${work.id}`;
    return <button type='button' className='pointer hover-work' onClick={_ => selectWork(work.id)} style={{ border: 'none', background: 'none', padding: 0 }}>
                <Card className={workClass} style={{ margin: '30px', borderRadius: '0px' }}>
                    <img src={clientImage} alt={t('Client card selector')} />
                    <div className="title">
                        <span className='name'>{work.name}</span>
                    </div>
                </Card>
            </button>
}

export function SelectWork(props: IProps) {
    const { t } = useTranslation();

    return <div className='SelectWork g-20 r h-center'>
        <NotificationsCenter className='e'/>

        <div className='e lg pd'>
            <div className='works-title e'>
                <span>{t('Clients')}</span>
                <img src="/img/works/clients.png" alt="gstore" />
            </div>
            <div className='works e'>
                {(props.works ?? []).map(w =>
                    <WorkCard
                        work={w}
                        key={w.id}
                        selectWork={props.selectWork} />)}
            </div>
        </div>
        {/* <div className='e lg pd'>
            <div className='works-title e'>
                <span>{t('Clients')}</span>
                <img src="/img/works/clients.png" alt="gstore" />
            </div>
        </div> */}
    </div>
}
